import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import LendersReportPageUI from './LendersReportPageUI'
import CacheManager from "../../../cache/CacheManager";
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";

class LendersReportPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorList: null,
            lendersReportList: null,
            onDownloadLendersReportRequested: false,
            checked: false,
            checkedAccount: false,
            response: null
        }
    }

    render() {
        return (
            <LendersReportPageUI
                context={this.props.context}
                errorList={this.state.errorList}
                lendersReportList={this.state.lendersReportList}
                response={this.state.response}
                checked={this.state.checked}
                checkedAccount={this.state.checkedAccount}
                onShowDetailsChange={this.onShowDetailsChange}
                onShowAccountDetailsChange={this.onShowAccountDetailsChange}
                onDownloadLendersReport={this.onDownloadLendersReport}
                onDownloadLendersReportRequested={this.state.onDownloadLendersReportRequested}
                onRefreshClick={this.onRefreshClick}
                onTypeChange={this.onTypeChange}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        // let cacheManager = new CacheManager({
        //     resource: `dummy`,
        //     cacheKey: CacheKeys.DSRAReport()
        // })
        // let checkedObj = cacheManager.getObjectFromCache()
        // if (checkedObj)
        //     this.setState({ checked: checkedObj.checked })
        this.getReport(context, context.filter)
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.match.params.year == prevProps.match.params.year && this.props.match.params.month == prevProps.match.params.month)
    //         return
    //     this.getReport(this.props.context)
    // }

    getReport(context, stp) {
        // const cacheKey = this.props.match.params.year && this.props.match.params.month
        //     ? CacheKeys.DSRAReport(this.props.match.params.year, this.props.match.params.month)
        //     : CacheKeys.DSRAReport();
        let cacheManager = new CacheManager({
            resource: `/api/su/accounts/lenders`,
            // cacheKey: CacheKeys.DSRAReport(this.props.match.params.year, this.props.match.params.month),
            cacheKey: CacheKeys.LendersReport(stp),
            callback: this.getReportCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context, {}, { stp: stp === 'stp' ? true : false })
        // if (!this.props.match.params.year || !this.props.match.params.month)
        //     cacheManager.getObject2(context, {}, {})
        // else
        //     cacheManager.getObject2(context, {}, {
        //         year: this.props.match.params.year,
        //         month: this.props.match.params.month,
        //     })
    }


    getReportCallback = (response) => {
        this.setState({ errorList: response.errorList, lendersReportList: response.lendersReportList, response: response })
    }

    onDownloadLendersReport = () => {
        let context = this.props.context
        this.setState({ onDownloadLendersReportRequested: true })
        RestApiUtils.get(context, `/api/su/accounts/lenders/excel/fileDownloadSignedUrl/true`,
            this.getDownloadLendersReportCallback, {}, {
            stp: context.filter === 'stp' ? true : false
        })
    }

    getDownloadLendersReportCallback = (response) => {
        this.setState({ onDownloadLendersReportRequested: false })

        if (response.errorList.length === 0) {
            const link = document.createElement('a')
            link.href = response.signedUrl.signedUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }

    onShowDetailsChange = () => {
        let newChecked = !this.state.checked
        // CacheManager.setObject(CacheKeys.LendersReport(), { checked: newChecked })
        this.setState({
            checked: newChecked
        })
    }

    onShowAccountDetailsChange = () => {
        let newChecked = !this.state.checkedAccount
        // CacheManager.setObject(CacheKeys.LendersReport(), { checkedAccount: newChecked })
        this.setState({
            checkedAccount: newChecked
        })
    }

    onTypeChange = (type) => {
        let context = this.props.context
        this.getReport(context, type)
    }

    onRefreshClick = () => {
        let context = this.props.context
        // CacheManager.removeObject(CacheKeys.DSRAReport(this.props.match.params.year, this.props.match.params.month))
        CacheManager.removeObject(CacheKeys.LendersReport(context.filter))
        this.setState({ lendersReportList: null, errorList: null }, () => {
            this.getReport(context, context.filter)
        })
    }
}

export default withRouter(LendersReportPageSF)